import React from 'react'
import { MenuMobile } from './MenuMobile'
import { MenuDesk } from './MenuDesk'

export const Header = () => {
  return (
    <div>
      <MenuMobile />
      <MenuDesk />
    </div>
  )
}
